/**
 * Get customer/requestor information from a shipment
 * Returns customer data if available, otherwise falls back to requestor data
 * 
 * @param {Object} shipment - The shipment object
 * @returns {Object} - Object with name, email, phone, company fields
 */
export const getShipmentRequester = (shipment) => {
  // If Customer exists, use it
  if (shipment?.Customer) {
    return {
      name: shipment.Customer.name || null,
      email: shipment.Customer.email || null,
      phone: shipment.Customer.phone || null,
      company: shipment.Customer.company || null,
    }
  }
  
  // If Customer is null and requestor exists, use requestor
  if (!shipment?.Customer && shipment?.requestor) {
    return {
      name: shipment.requestor.name || null,
      email: shipment.requestor.email || null,
      phone: shipment.requestor.phone || null,
      company: shipment.requestor.company || null,
    }
  }
  
  // Default fallback
  return {
    name: null,
    email: null,
    phone: null,
    company: null,
  }
}

/**
 * Get customer/requestor name with fallback
 * 
 * @param {Object} shipment - The shipment object
 * @param {string} fallback - Fallback text if no name found (default: 'Unknown Customer')
 * @returns {string} - Customer/requestor name or fallback
 */
export const getShipmentRequesterName = (shipment, fallback = 'Unknown Customer') => {
  const requester = getShipmentRequester(shipment)
  return requester.name || fallback
}

